import { customerConfirmComponent } from './customerConfirm.component';

export const customerConfirmStateName = 'app.customerConfirm';

export const customerConfirmState = ($stateProvider) => {
  'ngInject';

  const stateConfig = {
    name: customerConfirmStateName,
    url: '/customerConfirm/:customerToken/:requestId',
    params: {
      requestId: null
    },
    component: customerConfirmComponent.name,
    resolve: {
      isProtected: () => {
        'ngInject';
        return true;
      }
    }
  };

  $stateProvider.state(stateConfig);

  // Fallback route with missing requestId to fake a "redirect" to the new route.
  // Reason: ui router cannot create a route with optional parameters without
  // adding/needing a trailing slash at the url.
  const fallBackState = angular.copy(stateConfig);
  fallBackState.name = `${stateConfig.name}Fallback`;
  fallBackState.url = '/customerConfirm/:customerToken';
  $stateProvider.state(fallBackState);
};
